// extracted by mini-css-extract-plugin
export default {"menuItemSeparator":"xGzmV8CxlMuvQniRmdaE","menuItemSeparatorLine":"hbylaYCwImouayAhCECk"};